import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { useParams } from "react-router-dom";

import {
  bootstrapCameraKit,
  CameraKitSession,
  createMediaStreamSource,
  Transform2D,
} from "@snap/camera-kit";

const VirtualTryonFrontRagul = () => {
  const { lensId, lensGroup } = useParams();

  const [isBackFacing, setIsBackFacing] = useState(false);
  const [mediaStream, setMediaStream] = useState(null);
  const [requestMade, setRequestMade] = useState(false); // Add a state variable to track request status
  const [cameraView, setCameraView] = useState(true);

  useEffect(() => {
    if (!requestMade) {
      setRequestMade(true); // Set the flag to indicate the request has been made

      const liveRenderTarget = document.getElementById("canvas");
      const flipCamera = document.getElementById("flip");

      async function init() {
        const cameraKit = await bootstrapCameraKit({
          apiToken:
            "eyJhbGciOiJIUzI1NiIsImtpZCI6IkNhbnZhc1MyU0hNQUNQcm9kIiwidHlwIjoiSldUIn0.eyJhdWQiOiJjYW52YXMtY2FudmFzYXBpIiwiaXNzIjoiY2FudmFzLXMyc3Rva2VuIiwibmJmIjoxNzEwNDE2MTg5LCJzdWIiOiI0OGJmYzM4My1jZmQ1LTQxNTMtOWU5NS0wNjIyYzc1MDlhMDB-U1RBR0lOR35hNGRjOGQwOS01ZTkyLTQ1OWQtYTEzZi0yMDI2YzA4YmY3M2UifQ.r5ozTzw2qBu5AM3wwv4DivHN-VmsCTuEPMf3UsnACcA",
        });

        const session = await cameraKit.createSession({ liveRenderTarget });
        const { lenses } = await cameraKit.lensRepository.loadLensGroups([
          lensGroup,
        ]);

        const selectedLens = lenses.find((lens) => lens.id === lensId);

        if (selectedLens) {
          session.applyLens(selectedLens);
        }

        bindFlipCamera(session, flipCamera);
      }

      function bindFlipCamera(session: CameraKitSession, flipCamera) {
        flipCamera.style.cursor = "pointer";

        flipCamera.addEventListener("click", () => {
          updateCamera(session, flipCamera); // Pass flipCamera to updateCamera
        });

        updateCamera(session, flipCamera); // Pass flipCamera to updateCamera
      }

      async function updateCamera(session: CameraKitSession, flipCamera) {
        console.log("this is working");
        setIsBackFacing(!isBackFacing);

        flipCamera.innerText = isBackFacing
          ? "Switch to Front Camera"
          : "Switch to Back Camera";

        if (mediaStream) {
          session.pause();
          mediaStream.getVideoTracks()[0].stop();
        }

        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });

        setMediaStream(stream);

        const cameraType = cameraView ? "rear" : "front"; // Use cameraView state here
        const source = createMediaStreamSource(stream, {
          transform: Transform2D.MirrorX,
          cameraType: cameraType,
        });

        await session.setSource(source);

        session.play();
      }

      init();

      return () => {
        if (mediaStream) {
          mediaStream.getVideoTracks()[0].stop();
        }
      };
    }
  }, [isBackFacing, mediaStream, lensId, lensGroup, requestMade]);

  return (
    <div className={styles.container}>
      <canvas id="canvas" width={1024} />
      <span id="flip"></span>
    </div>
  );
};

export default VirtualTryonFrontRagul;
